import { render, staticRenderFns } from "./TheMemberCardIcon.vue?vue&type=template&id=6d493f98&"
import script from "./TheMemberCardIcon.vue?vue&type=script&lang=js&"
export * from "./TheMemberCardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports